// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"0d5fba45","371":"82e3c0a5","806":"94cdd6ad"}[chunkId] + ".chunk.js";
};